import React from 'react';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreGray1000Base, colorCoreBlack900Base, colorBrandYamahaRed, colorCoreWhite1000, greenSustainableColor, } from '@yme/tokens/colors';
import { RegularTextLevel3, RegularTextLevel5 } from '@yme/tokens/typography';
import { getIsNewLabel } from './helpers';
import { LabelStyled, LabelSaleStyled, FlexWrapperStyled, LabelSustainableStyled } from './styled';
/**
 * general props
 * @param isRightToLeft - default false
 * @param isMobileView - default false
 *
 * types of labels
 * @param isOnSale - default false
 * @param isOutOfStock  - default false - TODO: (D.K.) Out Of Scope [B2C-16466]
 * @param isSustainable - default false - TODO: (D.K.) Out Of Scope [B2C-16466]
 *
 * props for getting 'New' label
 * @param isNew - default false
 * @param embargoExternal - to calculate the receive (isNew) label
 * @param daysToShowNew - to calculate the receive (isNew) label
 *
 * @returns JSX Component
 */
export function ProductLabel(props) {
    const { 
    // general props
    isRightToLeft = false, isMobileView = false, 
    // types of labels
    isOutOfStock = false, isSaleLabelNeeded, isSustainable = false, 
    // props for New label
    isNew = false, embargoExternal = '', daysToShowNew, className, } = props;
    const { t } = useTranslation();
    const { isNewLabel } = getIsNewLabel({
        embargoExternal,
        daysToShowNew,
        isNew,
    });
    const onSaleLabel = t('common_sale_label');
    const newLabel = t('common_new_label');
    const outOfStockLabel = t('common_outOfStock_label');
    const sustainableLabel = t('common_sustainable_label');
    return (React.createElement(FlexWrapperStyled, { flexWrap: "wrap", gap: "10px", alignItems: "center", className: className },
        isSaleLabelNeeded && (React.createElement(LabelSaleStyled, { isRightToLeft: isRightToLeft, backgroundColor: colorBrandYamahaRed, isMobileView: isMobileView }, isMobileView ? (React.createElement(RegularTextLevel5, { as: "span", weight: 500, color: colorCoreWhite1000, isEllipsisEndingLine: true }, onSaleLabel)) : (React.createElement(RegularTextLevel3, { as: "span", color: colorCoreWhite1000, weight: 500, isEllipsisEndingLine: true }, onSaleLabel)))),
        isNewLabel && !isSaleLabelNeeded && (React.createElement(LabelStyled, { isRightToLeft: isRightToLeft, backgroundColor: colorCoreBlack900Base, isMobileView: isMobileView }, isMobileView ? (React.createElement(RegularTextLevel5, { as: "span", weight: 500, color: colorCoreWhite1000, isEllipsisEndingLine: true }, newLabel)) : (React.createElement(RegularTextLevel3, { as: "span", color: colorCoreWhite1000, weight: 500, isEllipsisEndingLine: true }, newLabel)))),
        isOutOfStock && (React.createElement(LabelStyled, { isRightToLeft: isRightToLeft, backgroundColor: colorCoreGray1000Base, isMobileView: isMobileView }, isMobileView ? (React.createElement(RegularTextLevel5, { as: "span", weight: 500, color: colorCoreWhite1000, isEllipsisEndingLine: true }, outOfStockLabel)) : (React.createElement(RegularTextLevel3, { as: "span", color: colorCoreWhite1000, weight: 500, isEllipsisEndingLine: true }, outOfStockLabel)))),
        isSustainable && (React.createElement(LabelSustainableStyled, { isRightToLeft: isRightToLeft, backgroundColor: greenSustainableColor, isMobileView: isMobileView }, isMobileView ? (React.createElement(RegularTextLevel5, { as: "span", weight: 500, color: colorCoreWhite1000, isEllipsisEndingLine: true }, sustainableLabel)) : (React.createElement(RegularTextLevel3, { as: "span", color: colorCoreWhite1000, weight: 500, isEllipsisEndingLine: true }, sustainableLabel))))));
}
